import React, { useState, useEffect, useCallback, useContext } from 'react';
import { MainContext } from './MainLayoutWrapper';
// import { VakcurContext } from './VakcurLayoutWrapper';

function VakcurFilter({ isSearch = false }) {
    // const vakcurContext = useContext(VakcurContext);
    const mainContext = useContext(MainContext);

    const getActiveFilterCount = isSearch ? mainContext.getActiveSearchFilterCount : mainContext.getActiveFilterCount;

    const [show, _setShow] = useState(false);
    const [insideFilter, setInsideFilter] = useState('');

    const activeFilters = isSearch ? mainContext.activeSearchFilters : mainContext.activeFilters;

    const currentActiveVak = activeFilters.vak !== null ? mainContext.vakken.find(v => v.slug === activeFilters.vak) : null;
    const currentActiveTraject = activeFilters.traject !== null ? mainContext.trajecten.find(t => t.slug === activeFilters.traject) : null;
    const currentActiveLestype = activeFilters.lestype !== null ? mainContext.lestypen.find(l => l.slug === activeFilters.lestype) : null;

    const currentActiveTijdvak = activeFilters.tijdvak !== null ? mainContext.tijdvakken.find(t => t.slug + '' === activeFilters.tijdvak) : null;
    const currentActiveVakoverstijging = activeFilters.vakoverstijging !== null ? mainContext.vakoverstijgingen.find(v => v.slug === activeFilters.vakoverstijging) : null;
    const currentActiveHuiswerk = activeFilters.huiswerk !== null ? mainContext.huiswerk.find(h => h.slug === activeFilters.huiswerk) : null;
    const currentActiveLeerfocus = activeFilters.leerfocus !== null ? mainContext.leerfocus.find(l => l.slug === activeFilters.leerfocus) : null;
    const currentActiveAfsluiting = activeFilters.afsluiting !== null ? mainContext.afsluitingen.find(a => a.slug === activeFilters.afsluiting) : null;
    const currentActivePta = activeFilters.pta !== null ? mainContext.pta.find(p => p.slug === activeFilters.pta) : null;
    const currentActivePortfolio = activeFilters.portfolio !== null ? mainContext.portfolio.find(p => p.slug === activeFilters.portfolio) : null;

    const insideFilterOptions = getInsideFilterOptions();
    const activeInsideFilterSlugs = getActiveInsideFilterSlugs();

    const keyUp = useCallback(e => {
        if (e.key.toLowerCase() === 'escape') hide();
    }, []);

    function toggleVisibility() {
        if (show) hide();
        else _setShow(true);
    }

    function hide() {
        setInsideFilter('');
        _setShow(false);
    }

    function clearFilters() {
        if (! isSearch) {
            mainContext.helperFunctions.nav('/');
        }

        mainContext.helperFunctions.setKlasFilter(null, isSearch);
        mainContext.helperFunctions.setVakFilter(null, isSearch);
        mainContext.helperFunctions.setTrajectFilter(null, isSearch);
        mainContext.helperFunctions.setLestypeFilter(null, isSearch);
        mainContext.helperFunctions.setTijdvakFilter(null, isSearch);
        mainContext.helperFunctions.setVakoverstijgingFilter(null, isSearch);
        mainContext.helperFunctions.setHuiswerkFilter(null, isSearch);
        mainContext.helperFunctions.setLeerfocusFilter(null, isSearch);
        mainContext.helperFunctions.setAfsluitingFilter(null, isSearch);
        mainContext.helperFunctions.setPtaFilter(null, isSearch);
        mainContext.helperFunctions.setPortfolioFilter(null, isSearch);
    }

    function getInsideFilterOptions() {
        switch (insideFilter) {
            case 'klas': return mainContext.klassen;
            case 'vak': return mainContext.vakken;
            case 'traject': return mainContext.trajecten;
            case 'lestype': return mainContext.lestypen;

            case 'tijdvak': return mainContext.tijdvakken;
            case 'vakoverstijging': return mainContext.vakoverstijgingen;
            case 'huiswerk': return mainContext.huiswerk;
            case 'leerfocus': return mainContext.leerfocus;
            case 'afsluiting': return mainContext.afsluitingen;
            case 'pta': return mainContext.pta;
            case 'portfolio': return mainContext.portfolio;

            default: return [];
        }
    }

    function getActiveInsideFilterSlugs() {
        switch (insideFilter) {
            case 'klas': return [activeFilters.klas];
            case 'vak': return [activeFilters.vak];
            case 'traject': return [activeFilters.traject];
            case 'lestype': return [activeFilters.lestype];

            case 'tijdvak': return [activeFilters.tijdvak];
            case 'vakoverstijging': return [activeFilters.vakoverstijging];
            case 'huiswerk': return [activeFilters.huiswerk];
            case 'leerfocus': return [activeFilters.leerfocus];
            case 'afsluiting': return [activeFilters.afsluiting];
            case 'pta': return [activeFilters.pta];
            case 'portfolio': return [activeFilters.portfolio];

            default: return [];
        }
    }

    function setCurrentInsideFilter(slug) {
        switch (insideFilter) {
            case 'klas':
                if (activeFilters.klas === slug) mainContext.helperFunctions.setKlasFilter(null, isSearch);
                else mainContext.helperFunctions.setKlasFilter(slug, isSearch);
                break;
            case 'vak':
                if (activeFilters.vak === slug) mainContext.helperFunctions.setVakFilter(null, isSearch);
                else mainContext.helperFunctions.setVakFilter(slug, isSearch);
                break;
            case 'traject':
                if (activeFilters.traject === slug) mainContext.helperFunctions.setTrajectFilter(null, isSearch);
                else mainContext.helperFunctions.setTrajectFilter(slug, isSearch);
                break;
            case 'lestype':
                if (activeFilters.lestype === slug) mainContext.helperFunctions.setLestypeFilter(null, isSearch);
                else mainContext.helperFunctions.setLestypeFilter(slug, isSearch);
                break;

            case 'tijdvak':
                if (activeFilters.tijdvak === slug) mainContext.helperFunctions.setTijdvakFilter(null, isSearch);
                else mainContext.helperFunctions.setTijdvakFilter(slug, isSearch);
                break;
            case 'vakoverstijging':
                if (activeFilters.vakoverstijging === slug) mainContext.helperFunctions.setVakoverstijgingFilter(null, isSearch);
                else mainContext.helperFunctions.setVakoverstijgingFilter(slug, isSearch);
                break;
            case 'huiswerk':
                if (activeFilters.huiswerk === slug) mainContext.helperFunctions.setHuiswerkFilter(null, isSearch);
                else mainContext.helperFunctions.setHuiswerkFilter(slug, isSearch);
                break;
            case 'leerfocus':
                if (activeFilters.leerfocus === slug) mainContext.helperFunctions.setLeerfocusFilter(null, isSearch);
                else mainContext.helperFunctions.setLeerfocusFilter(slug, isSearch);
                break;
            case 'afsluiting':
                if (activeFilters.afsluiting === slug) mainContext.helperFunctions.setAfsluitingFilter(null, isSearch);
                else mainContext.helperFunctions.setAfsluitingFilter(slug, isSearch);
                break;
            case 'pta':
                if (activeFilters.pta === slug) mainContext.helperFunctions.setPtaFilter(null, isSearch);
                else mainContext.helperFunctions.setPtaFilter(slug, isSearch);
                break;
            case 'portfolio':
                if (activeFilters.portfolio === slug) mainContext.helperFunctions.setPortfolioFilter(null, isSearch);
                else mainContext.helperFunctions.setPortfolioFilter(slug, isSearch);
                break;

            default: return;
        }
    }

    useEffect(() => {
        window.addEventListener('keyup', keyUp);
        return () => window.removeEventListener('keyup', keyUp);
    }, [keyUp]);

    return (<>
        <div className={`vakcur-filter-wrapper${isSearch ? ' vakcur-filter-wrapper--static' : ''}`}>
            <button type="button" className={`vakcur-filter-btn${show ? ' active' : ''}${isSearch ? ' vakcur-filter-btn--static' : ''}`} onClick={toggleVisibility}>
                {!!getActiveFilterCount() > 0 && <span className="vakcur-filter-btn__counter">{getActiveFilterCount()}</span>}
            </button>

            <div className={'vakcur-filter-modal' + (show ? ' show' : '') + (isSearch ? ' vakcur-filter-modal--static' : '')}>
                <div className="vakcur-filter-modal__bg" onClick={hide}></div>

                <div className="vakcur-filter-modal__inner">
                    <div className="vakcur-filter-modal__top">
                        {insideFilter === '' ? <span>Filters</span> : <button type="button" onClick={() => setInsideFilter('')}>{insideFilter}</button>}
                    </div>

                    <div className="vakcur-filter-modal__content-wrapper">
                        {insideFilter === '' && <>
                            <div className="vakcur-filter-modal__filter-list">
                                <button type="button" className="vakcur-filter-modal__filter" onClick={() => setInsideFilter('klas')}>
                                    <span className="vakcur-filter-modal__filter__title">Klas</span>
                                    <span className="vakcur-filter-modal__filter__content">{activeFilters.klas}</span>
                                </button>

                                <button type="button" className="vakcur-filter-modal__filter" onClick={() => setInsideFilter('vak')}>
                                    <span className="vakcur-filter-modal__filter__title">Vak</span>
                                    <div className="vakcur-filter-modal__filter__right">
                                        <span className="vakcur-filter-modal__filter__content">{!!currentActiveVak && currentActiveVak.name}</span>
                                    </div>
                                </button>

                                <button type="button" className="vakcur-filter-modal__filter" onClick={() => setInsideFilter('traject')}>
                                    <span className="vakcur-filter-modal__filter__title">Traject</span>
                                    <div className="vakcur-filter-modal__filter__right">
                                        <span className="vakcur-filter-modal__filter__content">{!!currentActiveTraject && currentActiveTraject.name}</span>
                                    </div>
                                </button>

                                <button type="button" className="vakcur-filter-modal__filter" onClick={() => setInsideFilter('lestype')}>
                                    <span className="vakcur-filter-modal__filter__title">Lestype</span>
                                    <div className="vakcur-filter-modal__filter__right">
                                        <span className="vakcur-filter-modal__filter__content">{!!currentActiveLestype && currentActiveLestype.name}</span>
                                    </div>
                                </button>

                                <button type="button" className="vakcur-filter-modal__filter" onClick={() => setInsideFilter('tijdvak')}>
                                    <span className="vakcur-filter-modal__filter__title">Tijdvak</span>
                                    <div className="vakcur-filter-modal__filter__right">
                                        <span className="vakcur-filter-modal__filter__content">{!!currentActiveTijdvak && currentActiveTijdvak.name}</span>
                                    </div>
                                </button>

                                <button type="button" className="vakcur-filter-modal__filter" onClick={() => setInsideFilter('vakoverstijging')}>
                                    <span className="vakcur-filter-modal__filter__title">Vakoverstijging</span>
                                    <div className="vakcur-filter-modal__filter__right">
                                        <span className="vakcur-filter-modal__filter__content">{!!currentActiveVakoverstijging && currentActiveVakoverstijging.name}</span>
                                    </div>
                                </button>

                                <button type="button" className="vakcur-filter-modal__filter" onClick={() => setInsideFilter('huiswerk')}>
                                    <span className="vakcur-filter-modal__filter__title">Huiswerk</span>
                                    <div className="vakcur-filter-modal__filter__right">
                                        <span className="vakcur-filter-modal__filter__content">{!!currentActiveHuiswerk && currentActiveHuiswerk.name}</span>
                                    </div>
                                </button>

                                <button type="button" className="vakcur-filter-modal__filter" onClick={() => setInsideFilter('leerfocus')}>
                                    <span className="vakcur-filter-modal__filter__title">Leerfocus</span>
                                    <div className="vakcur-filter-modal__filter__right">
                                        <span className="vakcur-filter-modal__filter__content">{!!currentActiveLeerfocus && currentActiveLeerfocus.name}</span>
                                    </div>
                                </button>

                                <button type="button" className="vakcur-filter-modal__filter" onClick={() => setInsideFilter('afsluiting')}>
                                    <span className="vakcur-filter-modal__filter__title">Afsluiting</span>
                                    <div className="vakcur-filter-modal__filter__right">
                                        <span className="vakcur-filter-modal__filter__content">{!!currentActiveAfsluiting && currentActiveAfsluiting.name}</span>
                                    </div>
                                </button>

                                <button type="button" className="vakcur-filter-modal__filter" onClick={() => setInsideFilter('pta')}>
                                    <span className="vakcur-filter-modal__filter__title">PTA</span>
                                    <div className="vakcur-filter-modal__filter__right">
                                        <span className="vakcur-filter-modal__filter__content">{!!currentActivePta && currentActivePta.name}</span>
                                    </div>
                                </button>

                                <button type="button" className="vakcur-filter-modal__filter" onClick={() => setInsideFilter('portfolio')}>
                                    <span className="vakcur-filter-modal__filter__title">Portfolio</span>
                                    <div className="vakcur-filter-modal__filter__right">
                                        <span className="vakcur-filter-modal__filter__content">{!!currentActivePortfolio && currentActivePortfolio.name}</span>
                                    </div>
                                </button>
                            </div>
                        </>}

                        {insideFilter !== '' && <>
                            <div className="vakcur-filter-modal__filter-options">
                                {insideFilterOptions.map(option => (
                                    <button key={`inside-filter-option-${option.slug}`} className={'vakcur-filter-modal__filter-option' + (activeInsideFilterSlugs.includes(option.slug) ? ' active' : '')} type="button" onClick={() => setCurrentInsideFilter(option.slug)}>
                                        <div className="vakcur-filter-modal__filter-option__indicator"></div>
                                        <span className="vakcur-filter-modal__filter-option__title">{option.human_name || option.name}</span>
                                    </button>
                                ))}
                            </div>
                        </>}
                    </div>

                    <div className="vakcur-filter-modal__bottom">
                        <button type="button" className="btn" onClick={clearFilters}>Wis filters</button>
                        <button type="button" className="btn btn--mustard" onClick={hide}>Bekijk resultaten</button>
                    </div>
                </div>
            </div>
        </div>
    </>);
}

export default VakcurFilter;